// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/Urbanist-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/search-icon.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Urbanist';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}); }

.nt-text-foreground-alpha-200 {
  display: none !important; }

.navbar {
  width: 100%;
  z-index: 600;
  height: 72px;
  padding: 0px;
  position: fixed;
  background-color: #0b1736 !important; }
  .navbar .container {
    margin-left: 0px;
    margin-right: 0px;
    min-width: 100%;
    height: 100%; }
  .navbar .navbar-collapse {
    height: fit-content;
    width: -webkit-fill-available;
    justify-content: space-between; }
  .navbar .navbar-brand {
    padding-top: 0.2rem;
    position: relative;
    cursor: pointer; }
    .navbar .navbar-brand img {
      width: 150px;
      max-height: 50px; }
    .navbar .navbar-brand .go-back {
      position: absolute;
      font-size: 12px;
      bottom: -35%; }
  .navbar .nv-bellContainer {
    stroke: white;
    transform: translateY(4px); }
  .navbar .searchinput-search-style {
    border: 1px solid #ffffff2e !important;
    border-radius: 4px;
    width: calc(30vw - 100px) !important;
    max-width: 300px;
    position: absolute;
    top: -15px;
    height: 1.5rem;
    text-indent: 10px;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-repeat: no-repeat;
    background-color: #060e21;
    background-position: 6px 7px; }
    .navbar .searchinput-search-style::placeholder {
      color: lightgray;
      opacity: 0.5;
      padding-left: 5px; }
  .navbar #search-button input {
    background-color: #0b1736;
    color: #fff;
    height: 100%;
    min-width: 100px; }
  .navbar #search-button .autocomplete-menu {
    position: absolute;
    width: 300px;
    top: 70%;
    list-style: none;
    background-color: white;
    box-shadow: rgba(36, 36, 49, 0.25) 0px 6px 12px -2px, rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
    margin-top: 20px; }
    .navbar #search-button .autocomplete-menu .autocomplete-item {
      margin-left: -20px;
      border-bottom: 0.5px solid #00000014;
      margin-right: 20px; }
      .navbar #search-button .autocomplete-menu .autocomplete-item:hover {
        background: rgba(41, 40, 68, 0.1);
        cursor: pointer; }
  @media only screen and (max-width: 1200px) {
    .navbar #search-button input {
      width: 20rem; } }
  @media only screen and (min-width: 1201px) {
    .navbar #search-button input {
      width: 35rem; } }
  .navbar #search-button input:focus {
    outline: none !important;
    border: unset; }
  .navbar #search-button .input-group-prepend {
    padding-top: 0.2rem; }
    .navbar #search-button .input-group-prepend .input-group-text {
      border: unset;
      background-color: #0b1736;
      color: #fff; }
  .navbar .navbar-button-group {
    margin-right: 7px; }
    .navbar .navbar-button-group svg {
      transform: translate(-1px, -3px); }
      .navbar .navbar-button-group svg:hover, .navbar .navbar-button-group svg:focus {
        color: rgba(255, 255, 255, 0.75); }
  .navbar .navbar-help-dropdown {
    margin-top: 10px !important;
    margin-right: 2px; }
    .navbar .navbar-help-dropdown:active, .navbar .navbar-help-dropdown:focus, .navbar .navbar-help-dropdown:focus-within {
      background-color: #12234f !important; }
  .navbar .navbar-button-gear {
    margin-bottom: 3px;
    margin-top: 10px !important; }
    .navbar .navbar-button-gear svg {
      transform: translate(-2px, -3px); }
  .navbar .navbar-nts-badge {
    transform: translate(-5px, -15px);
    border-radius: 12px;
    background-color: transparent !important; }
  .navbar .navbar-nts-badge-active {
    background-color: #ff5349 !important; }
  .navbar .navbar-bell-dropdown {
    max-width: 33px;
    margin-right: 2px; }
    .navbar .navbar-bell-dropdown .navbar-bell-toggle {
      padding-right: 0; }
    .navbar .navbar-bell-dropdown:active, .navbar .navbar-bell-dropdown:focus, .navbar .navbar-bell-dropdown:focus-within {
      background-color: #12234f !important; }
  .navbar .navbar-risk .accordion {
    min-width: 350px;
    width: 453px; }
  .navbar .navbar-risk .accordion-body {
    padding: 2px; }
  .navbar .accordion {
    min-width: 240px;
    width: 400px; }
    .navbar .accordion .accordion-item {
      border: unset;
      background-color: unset; }
    .navbar .accordion .accordion-body {
      margin-bottom: 10px; }
    .navbar .accordion .accordion-button {
      background: unset;
      color: #fff; }
      .navbar .accordion .accordion-button:hover {
        color: #4fc2d9; }
    .navbar .accordion .accordion-collapse {
      color: white !important; }
    .navbar .accordion .accordion-header {
      padding: 10px; }
    .navbar .accordion .accordion-header button::after {
      border: 0px !important;
      filter: invert(50%) !important; }
    .navbar .accordion .report-link {
      display: block;
      text-decoration: none;
      background: unset;
      text-indent: -10px;
      margin-left: 20px;
      padding: 10px; }
    .navbar .accordion .report-link:hover {
      color: #4fc2d9; }
    .navbar .accordion div.accordion-collapse.collapse.show {
      background: unset; }
  .navbar .navbar-nav-dropdown-split button {
    background-color: unset;
    padding: 0px;
    line-height: 18px;
    color: rgba(255, 255, 255, 0.55); }
  .navbar .navbar-nav-dropdown-split .navbar-nav-dropdown-button {
    min-width: 90px; }
  .navbar .navbar-nav-dropdown-split .dropdown-toggle-split {
    min-width: 20px;
    justify-content: center; }
  .navbar .navbar-nav-dropdown-split .dropdown-menu {
    padding-bottom: 2px; }
  .navbar .navbar-nav-dropdown-split .dropdown-divider {
    border-top: 1px solid white;
    opacity: 0.25;
    margin-top: 20px; }
  .navbar .navbar-nav-dropdown-split #navbar-nav-dropdown-menu-wm {
    padding-bottom: 20px; }
  .navbar #navbar-nav-dropdown-c {
    width: fit-content; }
  .navbar .navbar-nav-dropdown-c .dropdown-menu {
    padding-bottom: 20px; }
  .navbar .navbar-nav-dropdown-c .dropdown-divider {
    border-top: 1px solid white;
    opacity: 0.25;
    margin-top: 20px; }
  .navbar .navbar-nav-dropdown-item {
    width: max-content;
    height: 30px;
    text-align: center;
    padding: 7px;
    margin: 12px;
    font-size: 2rem; }
    .navbar .navbar-nav-dropdown-item a {
      text-decoration: unset; }
  .navbar .navbar-nav-item-active .navbar-nav-dropdown-button {
    color: white !important; }
  .navbar .navbar-nav-item-active .navbar-nav-dropdown-toggle {
    color: white !important; }
  .navbar .navbar-nav-item-active .accordion-header button {
    color: white !important; }
  .navbar .navbar-nav-dropdown-active a {
    color: white !important; }
  .navbar .navbar-dropdown {
    margin-top: 10px; }
    .navbar .navbar-dropdown .nav-link {
      color: white; }
    .navbar .navbar-dropdown .nav-link::after {
      content: none; }
    .navbar .navbar-dropdown svg {
      height: 18px; }
    .navbar .navbar-dropdown .dropdown-menu {
      color: white;
      background-color: #18244c;
      min-width: 200px; }
      .navbar .navbar-dropdown .dropdown-menu a {
        color: white;
        background-color: #18244c; }
    .navbar .navbar-dropdown .dropdown-menu a:hover {
      color: #4fc2d9 !important;
      background-color: #12234f !important; }
  .navbar .navbar-tool {
    flex-direction: row;
    display: inline-flex;
    align-items: center;
    margin-bottom: 6px;
    margin-left: 20px;
    margin-right: 0px; }
    .navbar .navbar-tool .notifications {
      margin-top: 4px; }
      .navbar .navbar-tool .notifications svg {
        transform: translate(-2px, -2px); }
  .navbar .navbar-tool .btn {
    margin-right: 7px;
    width: 1.7rem;
    height: 1.7rem; }
  .navbar .navbar-tool .profile-img {
    margin-right: 2px; }
  .navbar .option {
    color: #fff;
    position: relative;
    margin-top: 2px;
    align-self: center;
    margin-right: 20px; }
  .navbar .option:hover {
    background-color: #0b1736 !important; }
  .navbar .navbar-nav-dropdown {
    height: 100%; }
    .navbar .navbar-nav-dropdown .navbar-nav-item-active {
      border: unset; }
      .navbar .navbar-nav-dropdown .navbar-nav-item-active .navbar-nav-link {
        color: #4fc2d9 !important; }
    .navbar .navbar-nav-dropdown #navbar-nav-dropdown-title {
      border-bottom: solid 4px #4fc22c; }
      .navbar .navbar-nav-dropdown #navbar-nav-dropdown-title:focus {
        color: white !important;
        background-color: #12234f !important; }
    .navbar .navbar-nav-dropdown .nav-link {
      height: 50px;
      width: 270px; }
    .navbar .navbar-nav-dropdown .dropdown-menu {
      color: white;
      background-color: #18244c; }
    .navbar .navbar-nav-dropdown .dropdown-toggle {
      max-width: 11vw;
      display: inline-flex;
      white-space: break-spaces;
      text-align: center;
      align-items: center;
      padding: 0px;
      height: 100%; }
    .navbar .navbar-nav-dropdown a {
      color: white;
      font-size: 1rem; }
      .navbar .navbar-nav-dropdown a:hover, .navbar .navbar-nav-dropdown a:focus {
        color: #4fc2d9 !important; }
  .navbar .navbar-nav-container {
    height: 100%;
    width: 100%;
    max-width: calc(100vw - 950px);
    line-height: 18px;
    justify-content: center; }
  .navbar .navbar-nav-search {
    width: 20vw; }
  .navbar .navbar-nav-item {
    margin-right: 10px;
    padding-top: 4px;
    padding-bottom: 4px;
    transform: translateY(2px);
    text-align: center; }
    .navbar .navbar-nav-item .nav-link {
      font-size: 1rem;
      height: 100%;
      display: inline-flex;
      align-items: center;
      transform: translateY(-2px); }
    .navbar .navbar-nav-item .btn-primary.disabled {
      opacity: 0.28; }
    .navbar .navbar-nav-item .btn-primary:disabled {
      opacity: 0.28; }
    .navbar .navbar-nav-item .navbar-nav-dropdown-split button {
      color: rgba(255, 255, 255, 0.63); }
  .navbar .navbar-nav-item-active {
    border-bottom: solid 4px #4fc22c;
    opacity: 1 !important;
    padding-bottom: 0px !important; }
  .navbar .navbar-profile-dropdown .dropdown-menu {
    color: white;
    background-color: #18244c; }
  .navbar .navbar-profile-dropdown .dropdown-divider {
    border-top: 1px solid white;
    opacity: 0.25; }
  .navbar .navbar-profile-dropdown a {
    color: white; }
    .navbar .navbar-profile-dropdown a:hover, .navbar .navbar-profile-dropdown a:focus {
      color: #4fc2d9 !important;
      background-color: #12234f !important; }
  .navbar .profile-img {
    min-width: 2rem;
    min-height: 2rem;
    max-width: 2rem;
    max-height: 2rem;
    margin: unset;
    padding: unset;
    margin-top: 4px;
    cursor: pointer; }
  .navbar #profile-menu::after {
    content: none; }
  .navbar #profile-menu .navbar-profile-div {
    display: inline-flex;
    flex-direction: column;
    vertical-align: super;
    margin-left: 5px; }
  .navbar #profile-menu span {
    font-size: 12px;
    padding: unset;
    margin: unset; }
  .navbar #profile-menu span.navbar-profile-name {
    color: white; }
  .navbar #profile-menu span.navbar-profile-role {
    color: #4fc2d9; }
  .navbar .dark-mode,
  .navbar .light-mode {
    border-radius: 100%;
    width: 1.5rem;
    height: 1.5rem;
    margin-top: 0.5rem;
    padding: 0.5rem;
    align-items: center;
    vertical-align: center;
    background-color: transparent;
    border: unset; }
    .navbar .dark-mode svg,
    .navbar .light-mode svg {
      padding: unset;
      margin: unset;
      right: 232px;
      top: 23px;
      color: #fff;
      margin-bottom: 10px;
      margin-left: -1px; }
  .navbar .dark-mode.active,
  .navbar .light-mode.active {
    background-color: #12234f; }
    .navbar .dark-mode.active svg,
    .navbar .light-mode.active svg {
      color: #4fc2d9; }
  .navbar .settings {
    border-radius: 100%;
    width: 1.5rem;
    height: 1.5rem;
    margin-top: 0.5rem;
    padding: 0.5rem;
    align-items: center;
    vertical-align: center;
    background-color: transparent;
    border: unset; }
    .navbar .settings svg {
      padding: unset;
      margin: unset;
      right: 232px;
      top: 23px;
      color: #fff;
      margin-bottom: 10px; }
  .navbar .notifications {
    border-radius: 100%;
    width: 1.5rem;
    height: 1.5rem;
    margin-top: 0.5rem;
    padding: 0.5rem;
    align-items: center;
    vertical-align: center;
    background-color: transparent;
    border: unset; }
    .navbar .notifications svg {
      padding: unset;
      margin: unset;
      right: 232px;
      top: 23px;
      color: #fff;
      margin-bottom: 10px; }
  .navbar .ai-chat {
    width: 96px;
    height: 66px;
    margin: 2px;
    background-color: #0b1736;
    border-radius: unset; }
    .navbar .ai-chat .ai-chat-wrapper p {
      font-size: 15px;
      color: #ffffffa0;
      transition: color 0.3s ease;
      /* Add a transition for the color property */ }
    .navbar .ai-chat .ai-chat-wrapper svg {
      width: 2rem;
      height: 2rem;
      color: #ffffffa0;
      transition: color 0.3s ease;
      /* Add a transition for the color property */ }
    .navbar .ai-chat .ai-chat-wrapper:hover p,
    .navbar .ai-chat .ai-chat-wrapper:hover svg {
      color: white; }

@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
  .container .navbar-brand .go-back {
    bottom: -10px; }
  .navbar-nav-container {
    margin-left: 1.5rem; }
    .navbar-nav-container .btn-primary {
      font-size: 14px; } }
`, "",{"version":3,"sources":["webpack://./src/theme/_variables.scss","webpack://./src/layout/navigationbar.scss"],"names":[],"mappings":"AAqBA;EACE,uBAAuB;EACvB,4CAAmD,EAAA;;ACrBrD;EACE,wBAAuB,EAAA;;AAGzB;EAEE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,oCAAoD,EAAA;EAPtD;IAUI,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,YAAY,EAAA;EAbhB;IAiBI,mBAAmB;IACnB,6BAA6B;IAC7B,8BAA8B,EAAA;EAnBlC;IAuBI,mBAAmB;IACnB,kBAAkB;IAClB,eAAe,EAAA;IAzBnB;MA2BM,YDxBmB;MCyBnB,gBAAgB,EAAA;IA5BtB;MA+BM,kBAAkB;MAClB,eAAe;MACf,YAAY,EAAA;EAjClB;IAsCI,aAAa;IACb,0BAA0B,EAAA;EAvC9B;IA6CI,sCAAsC;IACtC,kBAAkB;IAClB,oCAAoC;IACpC,gBAAgB;IAChB,kBAAkB;IAClB,UAAU;IACV,cAAc;IACd,iBAAiB;IACjB,mDAA0C;IAC1C,4BAA4B;IAC5B,yBDjD+B;ICkD/B,4BAA4B,EAAA;IAxDhC;MA2DM,gBAAgB;MAChB,YAAY;MACZ,iBAAiB,EAAA;EA7DvB;IAmEM,yBDtE0B;ICuE1B,WD1EiB;IC2EjB,YAAY;IACZ,gBAAgB,EAAA;EAtEtB;IA0EM,kBAAkB;IAClB,YAAY;IACZ,QAAQ;IACR,gBAAgB;IAChB,uBAAuB;IACvB,yFACqC;IACrC,gBAAgB,EAAA;IAjFtB;MAmFQ,kBAAkB;MAClB,oCAAoC;MACpC,kBAAkB,EAAA;MArF1B;QAuFU,iCAAiC;QACjC,eAAe,EAAA;EAKrB;IA7FJ;MAiGQ,YAAY,EAAA,EACb;EAEH;IApGJ;MAsGQ,YAAY,EAAA,EACb;EAvGP;IA2GM,wBAAwB;IACxB,aAAa,EAAA;EA5GnB;IAgHM,mBAAmB,EAAA;IAhHzB;MAmHQ,aAAa;MACb,yBDvHwB;MCwHxB,WD3He,EAAA;ECMvB;IA2HI,iBAAiB,EAAA;IA3HrB;MA8HM,gCAAgC,EAAA;MA9HtC;QAkIQ,gCAAgC,EAAA;EAlIxC;IAwII,2BAA2B;IAC3B,iBAAiB,EAAA;IAzIrB;MA8IM,oCAA6D,EAAA;EA9InE;IAmJI,kBAAkB;IAClB,2BAA2B,EAAA;IApJ/B;MAsJM,gCAAgC,EAAA;EAtJtC;IA2JI,iCAAiC;IACjC,mBAAmB;IACnB,wCAAwC,EAAA;EA7J5C;IAiKI,oCAAoC,EAAA;EAjKxC;IAqKI,eAAe;IACf,iBAAiB,EAAA;IAtKrB;MAyKM,gBAAgB,EAAA;IAzKtB;MA+KM,oCAA6D,EAAA;EA/KnE;IAqLM,gBAAgB;IAChB,YAAY,EAAA;EAtLlB;IAyLM,YAAY,EAAA;EAzLlB;IA+LI,gBAAgB;IAChB,YAAY,EAAA;IAhMhB;MAmMM,aAAa;MACb,uBAAuB,EAAA;IApM7B;MAuMM,mBAAmB,EAAA;IAvMzB;MA0MM,iBAAiB;MACjB,WDjNiB,EAAA;MCMvB;QA8MQ,cDnNoB,EAAA;ICK5B;MAkNM,uBAAuB,EAAA;IAlN7B;MAqNM,aAAa,EAAA;IArNnB;MAyNM,sBAAsB;MACtB,8BAA8B,EAAA;IA1NpC;MA6NM,cAAc;MACd,qBAAqB;MACrB,iBAAiB;MACjB,kBAAkB;MAClB,iBAAiB;MACjB,aAAa,EAAA;IAlOnB;MAqOM,cD1OsB,EAAA;ICK5B;MAwOM,iBAAiB,EAAA;EAxOvB;IA8OM,uBAAuB;IACvB,YAAY;IACZ,iBAAiB;IACjB,gCAAgC,EAAA;EAjPtC;IAqPM,eAAe,EAAA;EArPrB;IAyPM,eAAe;IACf,uBAAuB,EAAA;EA1P7B;IA8PM,mBAAmB,EAAA;EA9PzB;IAkQM,2BAA2B;IAC3B,aAAa;IACb,gBAAgB,EAAA;EApQtB;IAwQM,oBAAoB,EAAA;EAxQ1B;IA6QI,kBAAkB,EAAA;EA7QtB;IAkRM,oBAAoB,EAAA;EAlR1B;IAsRM,2BAA2B;IAC3B,aAAa;IACb,gBAAgB,EAAA;EAxRtB;IA6RI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,eAAe,EAAA;IAlSnB;MAqSM,sBAAsB,EAAA;EArS5B;IA2SM,uBAAuB,EAAA;EA3S7B;IA+SM,uBAAuB,EAAA;EA/S7B;IAoTQ,uBAAuB,EAAA;EApT/B;IA2TM,uBAAuB,EAAA;EA3T7B;IAgUI,gBAAgB,EAAA;IAhUpB;MAmUM,YAAY,EAAA;IAnUlB;MAuUM,aAAa,EAAA;IAvUnB;MA2UM,YAAY,EAAA;IA3UlB;MA+UM,YAAY;MACZ,yBAAyB;MACzB,gBAAgB,EAAA;MAjVtB;QAoVQ,YAAY;QACZ,yBAAyB,EAAA;IArVjC;MA0VM,yBAAqC;MACrC,oCAA6D,EAAA;EA3VnE;IAgWI,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB,EAAA;IArWrB;MAwWM,eAAe,EAAA;MAxWrB;QA0WQ,gCAAgC,EAAA;EA1WxC;IAgXI,iBAAiB;IACjB,aAAa;IACb,cAAc,EAAA;EAlXlB;IAsXI,iBAAiB,EAAA;EAtXrB;IA0XI,WDhYmB;ICiYnB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,kBAAkB,EAAA;EA9XtB;IAkYI,oCAAoD,EAAA;EAlYxD;IAsYI,YAAY,EAAA;IAtYhB;MAyYM,aAAa,EAAA;MAzYnB;QA4YQ,yBAAqC,EAAA;IA5Y7C;MAiZM,gCAAgC,EAAA;MAjZtC;QAmZQ,uBAAuB;QACvB,oCAA6D,EAAA;IApZrE;MAyZM,YAAY;MACZ,YAAY,EAAA;IA1ZlB;MA8ZM,YAAY;MACZ,yBAAyB,EAAA;IA/Z/B;MAmaM,eAAe;MACf,oBAAoB;MACpB,yBAAyB;MACzB,kBAAkB;MAClB,mBAAmB;MACnB,YAAY;MACZ,YAAY,EAAA;IAzalB;MA6aM,YAAY;MACZ,eAAe,EAAA;MA9arB;QAkbQ,yBAAqC,EAAA;EAlb7C;IAwbI,YAAY;IACZ,WAAW;IACX,8BAA8B;IAC9B,iBAAiB;IACjB,uBAAuB,EAAA;EA5b3B;IAgcI,WAAW,EAAA;EAhcf;IAocI,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,0BAA0B;IAC1B,kBAAkB,EAAA;IAxctB;MA2cM,eAAe;MACf,YAAY;MACZ,oBAAoB;MACpB,mBAAmB;MACnB,2BAA2B,EAAA;IA/cjC;MAmdM,aAAa,EAAA;IAndnB;MAudM,aAAa,EAAA;IAvdnB;MA4dQ,gCAAgC,EAAA;EA5dxC;IAkeI,gCAAgC;IAChC,qBAAqB;IACrB,8BAA8B,EAAA;EApelC;IAyeM,YAAY;IACZ,yBAAyB,EAAA;EA1e/B;IA8eM,2BAA2B;IAC3B,aAAa,EAAA;EA/enB;IAmfM,YAAY,EAAA;IAnflB;MAufQ,yBAAqC;MACrC,oCAA6D,EAAA;EAxfrE;IA+fI,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,cAAc;IACd,eAAe;IACf,eAAe,EAAA;EAtgBnB;IA6gBI,aAAa,EAAA;EA7gBjB;IAihBM,oBAAoB;IACpB,sBAAsB;IACtB,qBAAqB;IACrB,gBAAgB,EAAA;EAphBtB;IAwhBM,eAAe;IACf,cAAc;IACd,aAAa,EAAA;EA1hBnB;IA6hBM,YAAY,EAAA;EA7hBlB;IAgiBM,cDriBsB,EAAA;ECK5B;;IAsiBI,mBAAmB;IACnB,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,sBAAsB;IACtB,6BAA6B;IAC7B,aAAa,EAAA;IA9iBjB;;MAijBM,cAAc;MACd,aAAa;MACb,YAAY;MACZ,SAAS;MACT,WD3jBiB;MC4jBjB,mBAAmB;MACnB,iBAAiB,EAAA;EAvjBvB;;IA6jBI,yBDzjBqC,EAAA;ICJzC;;MA+jBM,cDpkBsB,EAAA;ECK5B;IAokBI,mBAAmB;IACnB,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,sBAAsB;IACtB,6BAA6B;IAC7B,aAAa,EAAA;IA5kBjB;MA+kBM,cAAc;MACd,aAAa;MACb,YAAY;MACZ,SAAS;MACT,WDzlBiB;MC0lBjB,mBAAmB,EAAA;EAplBzB;IAwlBI,mBAAmB;IACnB,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,sBAAsB;IACtB,6BAA6B;IAC7B,aAAa,EAAA;IAhmBjB;MAmmBM,cAAc;MACd,aAAa;MACb,YAAY;MACZ,SAAS;MACT,WD7mBiB;MC8mBjB,mBAAmB,EAAA;EAxmBzB;IA6mBI,WAAW;IACX,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,oBAAoB,EAAA;IAjnBxB;MAqnBQ,eAAe;MACf,gBAAgB;MAChB,2BAA2B;MAAE,4CAAA,EAA6C;IAvnBlF;MA2nBQ,WAAW;MACX,YAAY;MACZ,gBAAgB;MAChB,2BAA2B;MAAE,4CAAA,EAA6C;IA9nBlF;;MAooBU,YAAY,EAAA;;AAOtB;EACI;IAGM,aAAa,EAAA;EAKnB;IACE,mBAAmB,EAAA;IADrB;MAGI,eAAe,EAAA,EAChB","sourcesContent":["$primaryFontColor: #fff;\n$secundaryFontColor: #4fc2d9;\n$thirdFontColor: #0b1736;\n$topMenuBackgroundColor: #0b1736;\n$sideBackgroundColor: #002044;\n$sideSubMenuBackgroundColor: #0b1736;\n$fontFamily: 'Urbanist';\n$leftMenuWidth: 5rem;\n$rightMenuWidth: 400px;\n$navBrandImageSize: 150px;\n$darkAndLightModeBackgroundColor: #12234f;\n$dropdownFiltersBackgroundColor: #060e21;\n$inputFocusBackgroundColor: #060e21;\n$containerScreenBackgroundColor: #050e25;\n$tableBackgroundColor: #0b1736;\n$secondarySubtitleColor: #838487;\n\n//FORMS\n$inputBackgroundColor: #021d3e;\n$btnPrimary: #257ee0;\n\n@font-face {\n  font-family: 'Urbanist';\n  src: url('../fonts/Urbanist-VariableFont_wght.ttf');\n}\n","@import \"../theme/_variables.scss\";\n\n.nt-text-foreground-alpha-200 {\n  display:none !important;\n}\n  \n.navbar {\n  // position: absolute;\n  width: 100%;\n  z-index: 600;\n  height: 72px;\n  padding: 0px;\n  position: fixed;\n  background-color: $topMenuBackgroundColor !important;\n\n  .container {\n    margin-left: 0px;\n    margin-right: 0px;\n    min-width: 100%;\n    height: 100%;\n  }\n\n  .navbar-collapse {\n    height: fit-content;\n    width: -webkit-fill-available;\n    justify-content: space-between;\n  }\n\n  .navbar-brand {\n    padding-top: 0.2rem;\n    position: relative;\n    cursor: pointer;\n    img {\n      width: $navBrandImageSize;\n      max-height: 50px;\n    }\n    .go-back {\n      position: absolute;\n      font-size: 12px;\n      bottom: -35%;\n    }\n  }\n\n  .nv-bellContainer {\n    stroke: white;\n    transform: translateY(4px);\n  }\n\n\n\n  .searchinput-search-style {\n    border: 1px solid #ffffff2e !important;\n    border-radius: 4px;\n    width: calc(30vw - 100px) !important;\n    max-width: 300px;\n    position: absolute;\n    top: -15px;\n    height: 1.5rem;\n    text-indent: 10px;\n    background: url(../assets/search-icon.svg);\n    background-repeat: no-repeat;\n    background-color: $inputFocusBackgroundColor;\n    background-position: 6px 7px;\n\n    &::placeholder {\n      color: lightgray;\n      opacity: 0.5;\n      padding-left: 5px;\n    }\n  }\n\n  #search-button {\n    input {\n      background-color: $topMenuBackgroundColor;\n      color: $primaryFontColor;\n      height: 100%;\n      min-width: 100px;\n    }\n\n    .autocomplete-menu {\n      position: absolute;\n      width: 300px;\n      top: 70%;\n      list-style: none;\n      background-color: white;\n      box-shadow: rgba(36, 36, 49, 0.25) 0px 6px 12px -2px,\n        rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;\n      margin-top: 20px;\n      .autocomplete-item {\n        margin-left: -20px;\n        border-bottom: 0.5px solid #00000014;\n        margin-right: 20px;\n        &:hover {\n          background: rgba(41, 40, 68, 0.1);\n          cursor: pointer;\n        }\n      }\n    }\n\n    @media only screen and (max-width: 1200px) {\n      \n\n      input {\n        width: 20rem;\n      }\n    }\n    @media only screen and (min-width: 1201px) {\n      input {\n        width: 35rem;\n      }\n    }\n\n    input:focus {\n      outline: none !important;\n      border: unset;\n    }\n\n    .input-group-prepend {\n      padding-top: 0.2rem;\n\n      .input-group-text {\n        border: unset;\n        background-color: $topMenuBackgroundColor;\n        color: $primaryFontColor;\n      }\n    }\n  }\n\n  .navbar-button-group {\n    margin-right: 7px;\n\n    svg {\n      transform: translate(-1px, -3px);\n\n      &:hover,\n      &:focus {\n        color: rgba(255, 255, 255, 0.75);\n      }\n    }\n  }\n\n  .navbar-help-dropdown {\n    margin-top: 10px !important;\n    margin-right: 2px;\n\n    &:active,\n    &:focus,\n    &:focus-within {\n      background-color: $darkAndLightModeBackgroundColor !important;\n    }\n  }\n\n  .navbar-button-gear {\n    margin-bottom: 3px;\n    margin-top: 10px !important;\n    svg {\n      transform: translate(-2px, -3px);\n    }\n  }\n\n  .navbar-nts-badge {\n    transform: translate(-5px, -15px);\n    border-radius: 12px;\n    background-color: transparent !important;\n  }\n\n  .navbar-nts-badge-active {\n    background-color: #ff5349 !important;\n  }\n\n  .navbar-bell-dropdown {\n    max-width: 33px;\n    margin-right: 2px;\n\n    .navbar-bell-toggle {\n      padding-right: 0;\n    }\n\n    &:active,\n    &:focus,\n    &:focus-within {\n      background-color: $darkAndLightModeBackgroundColor !important;\n    }\n  }\n\n  .navbar-risk {\n    .accordion {\n      min-width: 350px;\n      width: 453px;\n    }\n    .accordion-body {\n      padding: 2px;\n    }\n  }\n\n  //----------------------ACCORDION------------------------\n  .accordion {\n    min-width: 240px;\n    width: 400px;\n\n    .accordion-item {\n      border: unset;\n      background-color: unset;\n    }\n    .accordion-body {\n      margin-bottom: 10px;\n    }\n    .accordion-button {\n      background: unset;\n      color: $primaryFontColor;\n\n      &:hover {\n        color: $secundaryFontColor;\n      }\n    }\n    .accordion-collapse {\n      color: white !important;\n    }\n    .accordion-header {\n      padding: 10px;\n    }\n\n    .accordion-header button::after {\n      border: 0px !important;\n      filter: invert(50%) !important;\n    }\n    .report-link {\n      display: block;\n      text-decoration: none;\n      background: unset;\n      text-indent: -10px;\n      margin-left: 20px;\n      padding: 10px;\n    }\n    .report-link:hover {\n      color: $secundaryFontColor;\n    }\n    div.accordion-collapse.collapse.show {\n      background: unset;\n    }\n  }\n\n  .navbar-nav-dropdown-split {\n    button {\n      background-color: unset;\n      padding: 0px;\n      line-height: 18px;\n      color: rgba(255, 255, 255, 0.55);\n    }\n\n    .navbar-nav-dropdown-button {\n      min-width: 90px;\n    }\n\n    .dropdown-toggle-split {\n      min-width: 20px;\n      justify-content: center;\n    }\n\n    .dropdown-menu {\n      padding-bottom: 2px;\n    }\n\n    .dropdown-divider {\n      border-top: 1px solid white;\n      opacity: 0.25;\n      margin-top: 20px;\n    }\n\n    #navbar-nav-dropdown-menu-wm {\n      padding-bottom: 20px;\n    }\n  }\n\n  #navbar-nav-dropdown-c {\n    width: fit-content;\n  }\n\n  .navbar-nav-dropdown-c {\n    .dropdown-menu {\n      padding-bottom: 20px;\n    }\n\n    .dropdown-divider {\n      border-top: 1px solid white;\n      opacity: 0.25;\n      margin-top: 20px;\n    }\n  }\n\n  .navbar-nav-dropdown-item {\n    width: max-content;\n    height: 30px;\n    text-align: center;\n    padding: 7px;\n    margin: 12px;\n    font-size: 2rem;\n\n    a {\n      text-decoration: unset;\n    }\n  }\n\n  .navbar-nav-item-active {\n    .navbar-nav-dropdown-button {\n      color: white !important;\n    }\n\n    .navbar-nav-dropdown-toggle {\n      color: white !important;\n    }\n\n    .accordion-header {\n      button {\n        color: white !important;\n      }\n    }\n  }\n\n  .navbar-nav-dropdown-active {\n    a {\n      color: white !important;\n    }\n  }\n\n  .navbar-dropdown {\n    margin-top: 10px;\n\n    .nav-link {\n      color: white;\n    }\n\n    .nav-link::after {\n      content: none;\n    }\n\n    svg {\n      height: 18px;\n    }\n\n    .dropdown-menu {\n      color: white;\n      background-color: #18244c;\n      min-width: 200px;\n\n      a {\n        color: white;\n        background-color: #18244c;\n      }\n    }\n\n    .dropdown-menu a:hover {\n      color: $secundaryFontColor !important;\n      background-color: $darkAndLightModeBackgroundColor !important;\n    }\n  }\n\n  .navbar-tool {\n    flex-direction: row;\n    display: inline-flex;\n    align-items: center;\n    margin-bottom: 6px;\n    margin-left: 20px;\n    margin-right: 0px;\n\n    .notifications {\n      margin-top: 4px;\n      svg {\n        transform: translate(-2px, -2px);\n      }\n    }\n  }\n\n  .navbar-tool .btn {\n    margin-right: 7px;\n    width: 1.7rem;\n    height: 1.7rem;\n  }\n\n  .navbar-tool .profile-img {\n    margin-right: 2px;\n  }\n\n  .option {\n    color: $primaryFontColor;\n    position: relative;\n    margin-top: 2px;\n    align-self: center;\n    margin-right: 20px;\n  }\n\n  .option:hover {\n    background-color: $topMenuBackgroundColor !important;\n  }\n\n  .navbar-nav-dropdown {\n    height: 100%;\n\n    .navbar-nav-item-active {\n      border: unset;\n\n      .navbar-nav-link {\n        color: $secundaryFontColor !important;\n      }\n    }\n\n    #navbar-nav-dropdown-title {\n      border-bottom: solid 4px #4fc22c;\n      &:focus {\n        color: white !important;\n        background-color: $darkAndLightModeBackgroundColor !important;\n      }\n    }\n\n    .nav-link {\n      height: 50px;\n      width: 270px;\n    }\n\n    .dropdown-menu {\n      color: white;\n      background-color: #18244c;\n    }\n\n    .dropdown-toggle {\n      max-width: 11vw;\n      display: inline-flex;\n      white-space: break-spaces;\n      text-align: center;\n      align-items: center;\n      padding: 0px;\n      height: 100%;\n    }\n\n    a {\n      color: white;\n      font-size: 1rem;\n\n      &:hover,\n      &:focus {\n        color: $secundaryFontColor !important;\n      }\n    }\n  }\n\n  .navbar-nav-container {\n    height: 100%;\n    width: 100%;\n    max-width: calc(100vw - 950px);\n    line-height: 18px;\n    justify-content: center;\n  }\n\n  .navbar-nav-search {\n    width: 20vw;\n  }\n\n  .navbar-nav-item {\n    margin-right: 10px;\n    padding-top: 4px;\n    padding-bottom: 4px;\n    transform: translateY(2px);\n    text-align: center;\n\n    .nav-link {\n      font-size: 1rem;\n      height: 100%;\n      display: inline-flex;\n      align-items: center;\n      transform: translateY(-2px);\n    }\n\n    .btn-primary.disabled {\n      opacity: 0.28;\n    }\n\n    .btn-primary:disabled {\n      opacity: 0.28;\n    }\n\n    .navbar-nav-dropdown-split {\n      button {\n        color: rgba(255, 255, 255, 0.63);\n      }\n    }\n  }\n\n  .navbar-nav-item-active {\n    border-bottom: solid 4px #4fc22c;\n    opacity: 1 !important;\n    padding-bottom: 0px !important;\n  }\n\n  .navbar-profile-dropdown {\n    .dropdown-menu {\n      color: white;\n      background-color: #18244c;\n    }\n\n    .dropdown-divider {\n      border-top: 1px solid white;\n      opacity: 0.25;\n    }\n\n    a {\n      color: white;\n\n      &:hover,\n      &:focus {\n        color: $secundaryFontColor !important;\n        background-color: $darkAndLightModeBackgroundColor !important;\n      }\n    }\n  }\n\n  //----------PROFILE SECTION------------\n  .profile-img {\n    min-width: 2rem;\n    min-height: 2rem;\n    max-width: 2rem;\n    max-height: 2rem;\n    margin: unset;\n    padding: unset;\n    margin-top: 4px;\n    cursor: pointer;\n  }\n  .profile-img:hover {\n    //background-color: #002044;\n  }\n\n  #profile-menu::after {\n    content: none;\n  }\n  #profile-menu {\n    .navbar-profile-div {\n      display: inline-flex;\n      flex-direction: column;\n      vertical-align: super;\n      margin-left: 5px;\n    }\n\n    span {\n      font-size: 12px;\n      padding: unset;\n      margin: unset;\n    }\n    span.navbar-profile-name {\n      color: white;\n    }\n    span.navbar-profile-role {\n      color: $secundaryFontColor;\n    }\n  }\n  //----------END PROFILE SECTION------------\n  .dark-mode,\n  .light-mode {\n    border-radius: 100%;\n    width: 1.5rem;\n    height: 1.5rem;\n    margin-top: 0.5rem;\n    padding: 0.5rem;\n    align-items: center;\n    vertical-align: center;\n    background-color: transparent;\n    border: unset;\n\n    svg {\n      padding: unset;\n      margin: unset;\n      right: 232px;\n      top: 23px;\n      color: $primaryFontColor;\n      margin-bottom: 10px;\n      margin-left: -1px;\n    }\n  }\n\n  .dark-mode.active,\n  .light-mode.active {\n    background-color: $darkAndLightModeBackgroundColor;\n    svg {\n      color: $secundaryFontColor;\n    }\n  }\n\n  .settings {\n    border-radius: 100%;\n    width: 1.5rem;\n    height: 1.5rem;\n    margin-top: 0.5rem;\n    padding: 0.5rem;\n    align-items: center;\n    vertical-align: center;\n    background-color: transparent;\n    border: unset;\n\n    svg {\n      padding: unset;\n      margin: unset;\n      right: 232px;\n      top: 23px;\n      color: $primaryFontColor;\n      margin-bottom: 10px;\n    }\n  }\n  .notifications {\n    border-radius: 100%;\n    width: 1.5rem;\n    height: 1.5rem;\n    margin-top: 0.5rem;\n    padding: 0.5rem;\n    align-items: center;\n    vertical-align: center;\n    background-color: transparent;\n    border: unset;\n\n    svg {\n      padding: unset;\n      margin: unset;\n      right: 232px;\n      top: 23px;\n      color: $primaryFontColor;\n      margin-bottom: 10px;\n    }\n  }\n\n  .ai-chat {\n    width: 96px;\n    height: 66px;\n    margin: 2px;\n    background-color: #0b1736;\n    border-radius: unset;\n\n    .ai-chat-wrapper {\n      p {\n        font-size: 15px;\n        color: #ffffffa0;\n        transition: color 0.3s ease; /* Add a transition for the color property */\n      }\n\n      svg {\n        width: 2rem;\n        height: 2rem;\n        color: #ffffffa0;\n        transition: color 0.3s ease; /* Add a transition for the color property */\n      }\n\n      &:hover {\n        p,\n        svg {\n          color: white;\n        }\n      }\n    }\n  }\n}\n\n@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {\n    .container {\n      .navbar-brand {\n        .go-back {\n          bottom: -10px;\n        }\n      }\n    }\n    \n    .navbar-nav-container {\n      margin-left: 1.5rem;\n      .btn-primary {\n        font-size: 14px;\n      }\n    }\n  \n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
